import {
  getAllRows,
  getRow,
  createRow,
  updateRow,
  deleteRow,
} from "./supabaseRealtime";

export const listarColeccion = (coleccion) => getAllRows(coleccion);

export const obtenerDocumento = (coleccion, id) => getRow(coleccion, id);

export const crearDocumento = (coleccion, id, data) =>
  createRow(coleccion, id, data);

export const modificarDocumento = (coleccion, id, data) =>
  updateRow(coleccion, id, data);

export const eliminarDocumento = (coleccion, id) => deleteRow(coleccion, id);
